module.exports = __webpack_public_path__ + "img/image_5.57b85593.jpg";